module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-44.678f9bfc.svg";